export enum CreateMapErrorCode {
  NoHeaderColumnNames = 'NO_HEADER_COLUMN_NAMES',
}
